import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '../../common/Dropdown';
import Card, {
  CardContentPosition,
  CardSizes,
} from '../../../ui-components/Card/Card';
import Image, {
  ImageShapes,
  ImageSizes,
} from '../../../ui-components/Image/Image';
import Typography from '../../../ui-components/Typography/Typography';
import SearchHistory from '../../../hooks/interactsWithSearchHistory';
import pages from '../../../define/pages';
import qs from 'qs';
import BetaIcon, { IconSizes } from '../../Icons/Icon';
import { TRANSLATIONS } from '../../../../translations';

const SmartSearchDropdown = ({
  content,
  isOpen,
  searchValue,
  setSearchValue,
}) => {
  const _SEARCH_ALL_OPTIONS = app_main_wpml.search_all_options;

  const renderSeoPageCard = (item, index) => {
    const title = item.title;
    const link = item.link + `&query=${item.title}`;
    return (
      <Card
        onClick={() => {
          SearchHistory.append({ title: title, url: link }),
            setSearchValue(item.title);
        }}
        key={index}
        className="smart-search__container--body--scrollbox__dropdown--category--item items-center"
        link={link}
        size={CardSizes.full}
        image={
          <Image
            source={
              item.img_url
                ? item.img_url
                : 'https://freedome.s3.eu-central-1.amazonaws.com/images/fallback.jpg'
            }
            shape={ImageShapes.rounded}
            size={ImageSizes.medium}
            alt={item.img_url ? "Foto dell'esperienza" : 'Placeholder'}
          />
        }
        /* TODO: this is a quickfix */
        content={item.title.replace('in Spain', '')}
        contentPosition={CardContentPosition.right}
      />
    );
  };

  const renderSearchTermCard = (item, index) => {
    // TODO: Should this be swapped with SmartSearchCategoryCard.js???
    const title = item.title;
    return (
      <Card
        onClick={() => {
          SearchHistory.append({ title: title, url: item.link }),
            setSearchValue(title);
        }}
        key={index}
        className="smart-search__container--body--scrollbox__dropdown--category--item items-center"
        link={item.link}
        size={CardSizes.full}
        image={
          <Image
            source={
              item.img_url
                ? item.img_url
                : 'https://freedome.s3.eu-central-1.amazonaws.com/icons/pin-icon.svg'
            }
            shape={ImageShapes.rounded}
            size={ImageSizes.medium}
            asBackground={item.img_url ? false : true}
            overlaid
            alt={item.img_url ? 'Foto della località' : 'Pin geografico'}
          />
        }
        content={item.title}
        contentPosition={CardContentPosition.right}
      />
    );
  };

  const renderListingCard = (item, index) => {
    return (
      <Card
        key={index}
        className="smart-search__container--body--scrollbox__dropdown--category--item items-center listing-card"
        link={item.link}
        size={CardSizes.full}
        image={
          <Image
            source={item.img_url}
            shape={ImageShapes.squared}
            size={ImageSizes.medium}
            alt="Foto dell'attività"
          />
        }
        content={
          <>
            <section className="listing-card--title">
              <Typography classNames="truncate-two-lines" variant="p3">
                {item.title}
              </Typography>
            </section>
            <section className="listing-card--price">
              <Typography variant="p3" state="success">
                {TRANSLATIONS.FROM + ' '} <b> € {item.price_min_aggr}</b>{' '}
                {item?.price_label}
              </Typography>
            </section>
          </>
        }
        contentPosition={CardContentPosition.right}
      />
    );
  };

  const renderAllResultsCard = () => {
    if (!searchValue) return null;

    const redirectParams = qs.stringify({
      search: searchValue,
    });
    const redirectUrl = pages.catalogue + `?${redirectParams}`;

    return (
      <div className="w-100% border-t-secondary-50 border-b-secondary-50 pt-base pb-base">
        <Card
          onClick={() => {
            SearchHistory.append({
              title: `${searchValue}`,
              url: `${redirectUrl}`,
            }),
              setSearchValue(searchValue);
          }}
          key="all-results"
          className="smart-search__container--body--scrollbox__dropdown--category--item items-center"
          link={`${redirectUrl}`}
          size={CardSizes.full}
          image={
            <div
              style={{
                minWidth: '48px',
                width: '48px',
                flexShrink: 0,
              }}
            >
              <Image
                source="https://cdn.freedome.it/icons/magnifying-glass.svg?crop=1:1,smart&width=88"
                shape={ImageShapes.squared}
                size={ImageSizes.medium}
                asBackground={true}
                overlaid
                alt="Icona ricerca"
              />
            </div>
          }
          content={
            <div className="d-flex items-center justify-between">
              <Typography classNames="truncate-two-lines" variant="p3">
                {_SEARCH_ALL_OPTIONS} <strong>"{searchValue}"</strong>
              </Typography>
              <div style={{ width: '12px' }}>
                <BetaIcon name={'arrowRight'} size={IconSizes[12]} />
              </div>
            </div>
          }
          contentPosition={CardContentPosition.right}
        />
      </div>
    );
  };

  const renderCards = () => {
    const results = content.map((item, index) => {
      switch (item.type) {
        case 'seo_page':
          return renderSeoPageCard(item, index);
        case 'search_term':
          return renderSearchTermCard(item, index);
        case 'listing':
          return renderListingCard(item, index);
        default:
          return null;
      }
    });

    const allResultsCard = renderAllResultsCard();
    if (allResultsCard) {
      results.push(allResultsCard);
    }

    return results;
  };

  return (
    <>
      <Dropdown
        isOpen={isOpen}
        className={`smart-search__container--body--scrollbox__dropdown`}
      >
        {renderCards()}
      </Dropdown>
    </>
  );
};

SmartSearchDropdown.propTypes = {
  content: PropTypes.array,
  isOpen: PropTypes.bool,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
};

export default SmartSearchDropdown;
